import { NotifyHelper } from "../../../helpers/toast";
import { eThuPhiActionsObj } from "../../action-types/thu-phi/IThuPhiActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const thuPhiActions = {
  ...generateActions(eThuPhiActionsObj, "THU_PHI"),
  ...generateActionForKey(
    eThuPhiActionsObj,
    "THU_PHI",
    "CREATE_BIENLAITHU_SUCCESS",
    () => {
      NotifyHelper.Success("Đã tạo biên lai");
    }
  ),
  ...generateActionForKey(
    eThuPhiActionsObj,
    "THU_PHI",
    "CREATE_BIENLAITHU_ERROR",
    (m) => {
      NotifyHelper.Error(m.data);
    }
  ),
  ...generateActionForKey(
    eThuPhiActionsObj,
    "THU_PHI",
    "ADD_NEW_TAB_BY_ID_ERROR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eThuPhiActionsObj,
    "THU_PHI",
    "UPDATE_BIENLAITHU_SUCCESS",
    () => {
      NotifyHelper.Success("Đã sửa biên lai");
    }
  ),
  ...generateActionForKey(
    eThuPhiActionsObj,
    "THU_PHI",
    "UPDATE_BIENLAITHU_ERROR",
    (m) => {
      NotifyHelper.Error(m.data);
    }
  ),
  ...generateActionForKey(
    eThuPhiActionsObj,
    "THU_PHI",
    "LOAD_EDIT_BIENLAI_ERROR",
    (m) => {
      NotifyHelper.Error(m.data);
    }
  ),
};
